import { HeaderElement, HeaderElementType } from "src/types";

const resourcesHeader = {
  title: 'Resources',
  redirectLink: '',
  actionType: HeaderElementType.DRPODOWN,
  dropdown: [
    {
      title: 'Prescription Start Form',
      redirectLink: '/assets/request_form.pdf',
    }, {
      title: 'Afrezza PA Checklist',
      redirectLink: '/assets/Afrezza-Check-List-for-Prior-Authorization-Submission2.final_.pdf',
    }, {
      title: 'Sample Letter of Medical Necessity',
      redirectLink: '/assets/Letter_of_Medical_Necessity.pdf',
    }, {
      title: 'Sample Letter of Appeal',
      redirectLink: '/assets/Sample Letter of Appeal US-UNB-0471 May 2026.pdf',
    },
    // {
    //   title: "User Portal Guide ",
    //   redirectLink: "/assets/Mannkind Cares HCP Portal User Guide-US-AFR-3037 May 2026.pdf",
    // }, 
    {
      title: "Denial Reasons",
      redirectLink: "/assets/MannKind Cares Denial Reasons.pdf",
    },
    // {
    //   title: "Status and Substatus Data Dictionary",
    //   redirectLink: "/assets/Status and Substatus Data Dictionary.xlsx",
    // }
  ]
};


export const LOGGED_IN_VIDEO_NAMES = ["direct_expedited", "direct-coverage_co-pay"]

const publicResourcesHeader = {
  title: 'Resources',
  redirectLink: '',
  actionType: HeaderElementType.DRPODOWN,
  dropdown: [
    {
      title: 'Prescription Start Form',
      redirectLink: '/assets/request_form.pdf',
    }, {
      title: 'Afrezza PA Checklist',
      redirectLink: '/assets/Afrezza-Check-List-for-Prior-Authorization-Submission2.final_.pdf',
    }, {
      title: 'Sample Letter of Medical Necessity',
      redirectLink: '/assets/Letter_of_Medical_Necessity.pdf',
    }, {
      title: 'Sample Letter of Appeal',
      redirectLink: '/assets/Sample Letter of Appeal US-UNB-0471 May 2026.pdf',
    },
    {
      title: "Denial Reasons",
      redirectLink: "/assets/MannKind Cares Denial Reasons.pdf",
    }, {
      title: "User Portal Guide",
      redirectLink: "/assets/MannKind Cares HCP Portal August 2026 US-AFR-3148.pdf",
    }, {
      title: "Status and Substatus Data Dictionary",
      redirectLink: "/assets/Status and Substatus Data Dictionary Manufacture.xlsx",
    },
    {
        title:"Patient Postcard",
        redirectLink:"/assets/MannKind Cares Patient Postcard July 2026 US-AFR-3134.pdf"
      }
  ]
};


export const PublicHeader: HeaderElement[] = [
  {
    title: 'Welcome',
    redirectLink: '/users/sign_in',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Enrollment',
    redirectLink: '/enrollments/new',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Upload Prescription Start Form',
    redirectLink: '/faxes_ins/new',
    actionType: HeaderElementType.BUTTON,
  },
  publicResourcesHeader,
];

export const AuthenticatedManufactureHeader: HeaderElement[] = [
  {
    title: 'National',
    redirectLink: '/statistics',
    actionType: HeaderElementType.ROUTE,
  },
  {} as unknown as HeaderElement,
  {
    ...resourcesHeader,
    dropdown: [
      ...resourcesHeader.dropdown,
      {
        title: "User Portal Guide",
        redirectLink: "/assets/MannKind Cares HCP Portal August 2026 US-AFR-3148.pdf",
      }, {
        title: "Status and Substatus Data Dictionary",
        redirectLink: "/assets/Status and Substatus Data Dictionary Manufacture.xlsx",
      },{
        title:"Patient Postcard",
        redirectLink:"/assets/MannKind Cares Patient Postcard July 2026 US-AFR-3134.pdf"
      }
    ]
  },
];
export const AuthenticatedHCPHeader: HeaderElement[] = [

  {
    title: 'Cases',
    redirectLink: '/cases',
    actionType: HeaderElementType.ROUTE,
  },
  {
    title: 'Submit a Request',
    redirectLink: '/cases/new',
    actionType: HeaderElementType.ROUTE,
  },
  {
    ...resourcesHeader,
    dropdown: [
      ...resourcesHeader.dropdown,
      {
        title: "User Portal Guide",
        redirectLink: "/assets/MannKind Cares HCP Portal August 2026 US-AFR-3148.pdf",
      }, {
        title: "Status and Substatus Data Dictionary",
        redirectLink: "/assets/Status and Substatus Data Dictionary Manufacture.xlsx",
      },
      {
        title:"Patient Postcard",
        redirectLink:"/assets/MannKind Cares Patient Postcard July 2026 US-AFR-3134.pdf"
      }
    ]
  },
];


